import {
    CERTIFICATION_STATUS_EXPIRED,
    CERTIFICATION_STATUS_EXPIRING,
    getCertificationStatus
} from '@@utils/certifications';

import type { CertificationStatus, OrganizationMember } from './types';

export const TEST_ID = 'usersTableSection';

export const CERTIFICATION_FILTER_TEST_ID = 'usersTableSectionCertificationFilter';

export const ACTIONS_COLUMN_KEY = 'actions';

export const ACTIONS_COLUMN_WIDTH = '56px';

export const ADMIN_ROLE = 'ADMIN';

export const CERTIFICATIONS_COLUMN_KEY = 'certifications';

export const EMAIL_COLUMN_KEY = 'email';

export const EMPTY_CELL_TEXT = '—';

export const NAME_COLUMN_KEY = 'name';

export const NAME_SEPARATOR = ' ';

export const ROLE_COLUMN_KEY = 'role';

export const ROLE_SEPARATOR = ', ';

export const STATUS_COLUMN_KEY = 'status';

export const ALL_CERTIFICATION_STATUSES_FILTER = 'all';

export const EXPIRING_CERTIFICATIONS_FILTER = 'expiring';

export const EXPIRED_CERTIFICATIONS_FILTER = 'expired';

export const NO_CERTIFICATIONS_FILTER = 'none';

export const NO_CERTIFICATION_COUNT = 0;

// The names arrive from the API, which leaves them out of a record whose user no
// longer exists, so both halves can be null as well as missing.
export const getMemberName = (firstName?: string | null, lastName?: string | null): string =>
    [firstName, lastName].filter(Boolean).join(NAME_SEPARATOR);

export const getMemberRole = (roles: string[]): string =>
    roles.includes(ADMIN_ROLE) ? ADMIN_ROLE : roles.join(ROLE_SEPARATOR);

const getHasCertificationWithStatus = (
    member: OrganizationMember,
    certificationStatus: CertificationStatus
): boolean =>
    (member.applicatorCertifications ?? []).some(
        certification =>
            getCertificationStatus(certification.certificationExpirationDate) ===
            certificationStatus
    );

// The filter reads the certifications the members list already carries, so picking
// a status never costs another request.
const CERTIFICATION_FILTER_PREDICATES: Record<
    string,
    ((member: OrganizationMember) => boolean) | undefined
> = {
    [EXPIRED_CERTIFICATIONS_FILTER]: member =>
        getHasCertificationWithStatus(member, CERTIFICATION_STATUS_EXPIRED),
    [EXPIRING_CERTIFICATIONS_FILTER]: member =>
        getHasCertificationWithStatus(member, CERTIFICATION_STATUS_EXPIRING),
    [NO_CERTIFICATIONS_FILTER]: member =>
        (member.applicatorCertifications ?? []).length === NO_CERTIFICATION_COUNT
};

export const filterMembersByCertificationStatus = (
    members: OrganizationMember[],
    certificationStatusFilter: string
): OrganizationMember[] => {
    const matchesFilter = CERTIFICATION_FILTER_PREDICATES[certificationStatusFilter];

    return matchesFilter ? members.filter(matchesFilter) : members;
};
